<template>
  <Card shadow v>
    <p slot="title">
      下注人数统计
      <span class="card-small-title">(每日单位)</span>
    </p>
    <div slot="extra">
      <Button class="mr-1" :loading="itemsLoading" type="info" @click="fristData">更新数据</Button>
      <DatePicker
        :value="selectDate"
        confirm
        type="daterange"
        class="home-Date-input"
        placeholder="开始日期 - 结束日期"
        :options="options"
        @on-change="change"
        @on-ok="linkonlinemem"
        :clearable="false"
        placement="bottom-end"
      ></DatePicker>
    </div>
    <Row type="flex" justify="space-around">
      <!-- <Col class="mb-1">
        <div class="home-smallCard-data default">
          <p class="home-smallCard-data-title">总下注人数</p>
          <div class="home-smallCard-data-content">
            <Icon type="md-people" />
            {{allnumber | commaFormat}}
          </div>
        </div>
      </Col> -->
      <Col class="mb-1" v-for="(it, index) in siteNumber" :key="index">
        <div class="home-smallCard-data" :style="{ background:  colors[index] }">
          <p class="home-smallCard-data-title">{{ it.site }} 下注人数</p>
          <div class="home-smallCard-data-content">
            <Icon type="md-people" />
            {{it.data | commaFormat}}
          </div>
        </div>
      </Col>
      <Col span="24" class="mt-2">
        <v-chart autoresize :options="polar" style="height:300px;padding-top: 2px" />
      </Col>
    </Row>
  </Card>
</template>
<script>
import moment from "moment-timezone";
import echartsmixins from '../mixins/echarts'
export default {
  name: 'ChartsBetNumber',
  mixins: [echartsmixins],
  data () {
    return {
      items: [],
      itemsTime: null,
      itemsLoading: false,
      selectDate: [],
      ApiDate: [],
      options: {
        disabledDate (date) {
          const now = new Date()
          const target = new Date(date)
          return target > now
        },
        shortcuts: [
          {
            text: '本周',
            value () {
              const now = new Date()

              // 計算本週週一
              const startOfWeek = new Date(now)
              const day = now.getDay() // 星期幾（0 = 星期日）
              const diffToMonday = day === 0 ? -6 : 1 - day
              startOfWeek.setDate(now.getDate() + diffToMonday)
              startOfWeek.setHours(0, 0, 0, 0)

              // 計算本週週日
              const endOfWeek = new Date(now)
              endOfWeek.setHours(23, 59, 59, 999)
              return [startOfWeek, endOfWeek];
            }
          },
          {
            text: '上周',
            value () {
              const now = new Date()
              const day = now.getDay()
              const diffToLastMonday = day === 0 ? -13 : -6 - day

              const lastWeekStart = new Date(now)
              lastWeekStart.setDate(now.getDate() + diffToLastMonday)
              lastWeekStart.setHours(0, 0, 0, 0)

              const lastWeekEnd = new Date(lastWeekStart)
              lastWeekEnd.setDate(lastWeekStart.getDate() + 6)
              lastWeekEnd.setHours(23, 59, 59, 999)
              return [lastWeekStart, lastWeekEnd];
            }
          },
          {
            text: '本月',
            value () {
              const now = new Date()

              const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1)
              const thisMonthEnd = new Date(now)
              thisMonthEnd.setHours(23, 59, 59, 999)
              return [thisMonthStart, thisMonthEnd];
            }
          },
          {
            text: '上月',
            value () {
              const now = new Date()

              const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1)
              const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0)
              lastMonthEnd.setHours(23, 59, 59, 999)
              return [lastMonthStart, lastMonthEnd];
            }
          }
        ]
      },
      polar: {
        // title: {
        //   text: '各站点上线人数',
        //   subtext: '每小时单位',
        //   padding: 10,
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          position: function (pt) {
            return [pt[0], '10%'];
          },
          formatter(params) {
            let output = `<strong>${params[0].data.time || params[0].name}</strong><br/>`
            params.forEach(item => {
              const data = item.data
              output += `
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background:${item.color}"></span>
                ${item.seriesName}<br/>
                下注人数：${data.value}<br/>
              `
            })
            return output
          }
        },
        toolbox: {
          top: 20,
          right: 10,
          feature: {
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: function (opt) {
                let axisData = opt.xAxis[0].data; //坐标数据
                let series = opt.series; //折线图数据
                let tdHeads = '<td  style="padding: 0 10px">时间</td>'; //表头
                let tdBodys = ''; //数据
                series.forEach(function (item) {
                  //组装表头
                  tdHeads += `<td style="padding: 0 10px">${item.name}</td>`;
                });
                let table = `<table border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
                for (let i = 0, l = axisData.length; i < l; i++) {
                  for (let j = 0; j < series.length; j++) {
                    //组装表数据
                    let value = typeof series[j].data[i] === 'object'
                      ? series[j].data[i].value
                      : series[j].data[i]

                    tdBodys += `<td>${value}</td>`;
                  }
                  table += `<tr><td style="padding: 0 10px">${axisData[i]}</td>${tdBodys}</tr>`;
                  tdBodys = '';
                }
                table += '</tbody></table>';
                return table;
              }
            },
            magicType: { show: true, type: ['line', 'bar'] },
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {}
          }
        },
        legend: {
          padding: 10,
          data: [],
          selected: {}
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          },
          data: [],
          name: '日',
        },
        yAxis: [
          {
            name: '人数',
            type: 'value',
            position: 'left',
            boundaryGap: [0, '100%'],
            axisLine: {
              lineStyle: {
                color: '#1d3c78'
              }
            }
          }
        ],
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }, {
          start: 0,
          end: 100,
          handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '80%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }],
        series: [],
      }
    }
  },
  computed: {
    siteNumber () {
      return this.polar.series.map(it => {
        const obj = {}
        obj.site = it.name
        obj.data = 0
        obj.data += it.data[it.data.length - 1].memcou
        return obj
      })
    }
  },
  created () {
    this.fristData()
  },
  beforeDestor () {
    clearInterval(this.itemsTime)
  },
  methods: {
    fristData () {
      let day1 = moment().startOf('isoweek').format("YYYY-MM-DD")
      let day7 = moment().format("YYYY-MM-DD")
      let start = moment(day1).subtract(1, 'seconds').format("YYYY-MM-DD HH:mm:ss")
      this.selectDate = [day1, day7]
      this.ApiDate = [start, moment().format("YYYY-MM-DD HH:mm:00")]
      this.linkonlinemem()
    },
    change (val) {
      this.selectDate = val
      let start = moment(val[0]).subtract(1, 'seconds').format("YYYY-MM-DD HH:mm:ss")
      this.ApiDate = [start, `${val[1]} 23:00:00`]
    },
    refresh () {
      this.polar.xAxis.data = []
      this.polar.series = []
      this.polar.legend.data = []
    },
    async linkonlinemem () {
      this.itemsLoading = true
      this.refresh()
      try {
        const obj = {
          siteid: '0',
          startTiem: this.ApiDate[0],
          endTiem: this.ApiDate[1]
        }
        const res = await this.$axios.linkbetmem(obj)
        
        if ('status' in res && res.status === 0) return
        let start_date = moment(this.selectDate[0], "YYYY-MM-DD");
        let end_date = moment(this.selectDate[1], "YYYY-MM-DD");
        let days = end_date.diff(start_date, "days");

        this.items = res.map((it, index) => {
          let data = []
          let x = 0
          for (let i = 0; i <= days; i++) {
            let length = 0
            let text = moment(start_date, "YYYY-MM-DD").add(i, 'days');
            let time = text.format("YYYY-MM-DD")
            if (index == 0) this.polar.xAxis.data.push(time)
            length = it.data.length
            do {
              if (length == x) {
                data.push({
                  value: 0,
                  memcou: 0,
                  time: time,
                  name: it.memname
                })
                break;
              } else {
                const col = it.data[x]
                if (col.date == time) {
                  data.push({
                    value: col.memcou,
                    memcou: col.memcou,
                    time: col.date,
                    name: it.memname
                  })
                  x += 1;
                  break;
                } else {
                  data.push({
                    value: 0,
                    memcou: 0,
                    time: time,
                    name: it.memname
                  })
                  break;
                }
              }
            } while (x <= length)
          }
          const series = this.seriesObject(it, index, data)
          this.polar.series.push(series)
          this.polar.legend.data.push(it.memname)
          // this.polar.legend.selected[it.memname] = it.memname == '下注人数'
          return it
        })
        this.timeItemsLoading()
      } catch (error) {
        console.log(error);
        this.timeItemsLoading()
      }
    },
    seriesObject (val, index, data) {
      return {
        name: val.memname,
        type: 'line',
        smooth: true,
        data: data,
        itemStyle: { color: this.colors[index] },
        markPoint: {
          data: [
            { type: 'max', name: '最大值' },
          ]
        }
      }
    },
    timeItemsLoading () {
      setTimeout(() => this.itemsLoading = false, 2000)
    }
  }
}
</script>